import { useState } from "react";

import { Button, Menu, MenuItem, Position } from "@blueprintjs/core";

import { Popover } from "@/components/helpers/ui/blueprint-overrides/Popover";
import { ShareStatus } from "@/components/pieces/roleplays/sharing/scenario-share/constants";
import { PermissionSelectorProps } from "@/components/pieces/roleplays/sharing/scenario-share/types";
import { PermissionLevel } from "@/graphql";

export function PermissionSelector({
  selectedPermission,
  onPermissionChange,
}: PermissionSelectorProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleToggleMenu = (): void => {
    setIsOpen(!isOpen);
  };

  const handleCloseMenu = (): void => {
    setIsOpen(false);
  };

  const handlePermissionSelect = (permission: PermissionLevel): void => {
    handleCloseMenu();
    onPermissionChange(permission);
  };

  return (
    <Popover
      canEscapeKeyClose={true}
      position={Position.BOTTOM_LEFT}
      onClose={handleCloseMenu}
      isOpen={isOpen}
      minimal={true}
      content={
        <Menu>
          <MenuItem
            text={ShareStatus[PermissionLevel.View]}
            onClick={() => handlePermissionSelect(PermissionLevel.View)}
          />
          <MenuItem
            text={ShareStatus[PermissionLevel.Share]}
            onClick={() => handlePermissionSelect(PermissionLevel.Share)}
          />
        </Menu>
      }
      css={{
        height: "fit-content",
      }}
    >
      <Button
        rightIcon="caret-down"
        style={{
          backgroundColor: "#0719560A",
          fontSize: 14,
          textWrap: "nowrap",
          padding: "8px 16px",
        }}
        onClick={handleToggleMenu}
        text={ShareStatus[selectedPermission] || selectedPermission}
      />
    </Popover>
  );
}
